import React from 'react';
import type {
  InsuringAgreements,
  RaterXCoverage,
} from '../../../../../../api/types/rater-x-preset';
import type { UpdateCoveragePayload } from '../../../../../../reducer';
import {
  formatInsuringAgreementsForState,
  getDefaultInsuringAgreementValues,
} from '../../amendatory-coverages/line-items/AmendInsuringAgreement';
import type { InsuringAgreementsFormValues } from '../InsuringAgreementsModal';
import { InsuringAgreementsModal } from '../InsuringAgreementsModal';

const RaterXAmendInsuringAgreementModal = ({ data, close }: ModalProps) => {
  const onSubmit = (formValues: InsuringAgreementsFormValues) => {
    const _agreements = formatInsuringAgreementsForState(formValues);

    data.setCoverage({
      id: data.coverageState.id,
      isSelected: true,
      value: {
        props: {
          agreements: {
            values: _agreements as unknown as InsuringAgreements[],
          },
        },
      },
    });
  };

  return (
    <InsuringAgreementsModal
      close={close}
      data={{
        onSubmit,
        agreements: getDefaultInsuringAgreementValues(
          data.coverageState.value?.props?.agreements
            ?.values as InsuringAgreements[]
        ),
      }}
    />
  );
};

type ModalProps = {
  data: {
    coverageState: RaterXCoverage;
    setCoverage: (payload: UpdateCoveragePayload) => void;
  };
  close: () => void;
};

export const RaterXAmendInsuringAgreementModalConfig = {
  RaterXAmendInsuringAgreementModal: {
    component: RaterXAmendInsuringAgreementModal,
    config: {
      title: 'Insuring Agreements',
      fullWidth: true,
      maxWidth: 'md',
    },
  },
};
